import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParkingVariableModule } from './parking-variable/parking-variable.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ParkingVariableModule],
  exports: [ParkingVariableModule],
})
export class ParkingModule {}
